import { Observable } from "rxjs";
import { UsuarioUltConexionModel } from "../usuario-ult-conexion.model";
import { UsuarioRequestModel } from "../usuario-request.model";

export abstract class UsuarioGateway {
    abstract ultimaConexion(usuario:UsuarioRequestModel): Observable<UsuarioUltConexionModel>;
}